import { BundleInterface } from "../interfaces/BundleInterface/Bundle";
import { CreateBundleInterface } from "../interfaces/BundleInterface/CreateBundle";
import BaseService from "./BaseService";

export class BundleService extends BaseService<BundleInterface, CreateBundleInterface>{ 
    constructor(){
        let url: string = '/bundle/admin'
        super(url)
    }
}